import { getUserDetails, makeGetCall, makePostCall } from './helper';

const STORAGE_KEY = 'user-preferred-keys';

const getUsername = () => {
  const u = getUserDetails();
  return u?.username || u?.user_name || null;
};

// Hydrate localStorage from backend on app load
export const preloadUserHotkeys = async () => {
  const username = getUsername();
  if (!username) return null;

  try {
    const resp = await makeGetCall(
      `/get-all-user-preferences?username=${encodeURIComponent(username)}`
    );
    const keysObj = resp?.data?.data?.hotkeys;
    if (keysObj && typeof keysObj === 'object') {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(keysObj));
      return keysObj;
    }
  } catch (e) {
    console.warn('hotkeysApi: preload failed', e);
  }
  return null;
};

// Push whatever is currently in localStorage to the backend
export const persistUserHotkeys = async () => {
  const username = getUsername();
  if (!username) return;

  try {
    const currentKeysStr = localStorage.getItem(STORAGE_KEY) || '{}';
    const keysObj = JSON.parse(currentKeysStr);

    await makePostCall('/save-user-preference', {
      username,
      type: 'hotkeys',
      value: keysObj,
    });
  } catch (e) {
    console.error('hotkeysApi: failed to persist hotkeys', e);
  }
};
